export const storageKey = "inlabB2BSubscribedForPushes";
export const publicVapidKey = process.env.VAPID_PUBLIC_KEY as string;